module.exports = __webpack_public_path__ + "img/lumi_accessories.a25336ca.jpg";